import { InteractionStatusEnum } from '../_helpers/interaction-status.enum';
import { Agent } from './agent';
import { AnalysisHistory } from './analysis-history';
import { Checklist } from './checklist';
import { Contestation } from './contestation';
import { Customer } from './customer';
import { Deserializable } from './deserializable';
import { FileInfo } from './fileInfo';
import { InteractionAttachment } from './interaction-attachment';
import { InteractionCustomer } from './interaction-customer';
import { InteractionDebt } from './interaction-debt';
import { InteractionStatus } from './interaction-status';
import { Justification } from './justification';
import { MonitorInteractionItem } from './monitor-interaction-item';
import { Operation } from './operation';
import { Segment } from './segment';
import { Transcription } from './transcription';
import { User } from './user';

export class Interaction implements Deserializable {
  id: number;
  agentName?: string;
  status?: InteractionStatus;
  contactDate?: Date;
  monitorDate?: Date;
  grade?: number | string;
  deadLine?: Date;
  operation?: Operation;
  customerId?: number;
  feedback?: string;
  monitorDuration?: string;
  userMonitor?: User;
  userSupervisor?: User;
  userOperator: any;
  customer?: Customer;
  evaluation?: MonitorInteractionItem[];
  silenceTime?: string;
  silencePercent?: any;
  fileInfo: FileInfo;
  transcription: Transcription;
  duration?: any;
  audioUrl: string;
  audioStem?: string;
  originalFileName?: string;
  monthlyCycleName: string;
  dateFeedback: Date;
  dateFeedbackAccepted: Date;
  userFeedback: User;
  userFeedbackAccepted: User;
  metadata: any;

  inAnalysis: boolean = false;

  analysisHistories: AnalysisHistory[];

  metadataId: any;

  itensToUpdate?: MonitorInteractionItem[] = [];
  segment: Segment;
  contestations: Contestation[];
  checklist?: Checklist;
  interactionChecklists?: {
    id: number;
    grade: number | string;
    checkList: Checklist;
    weight: number;
    notApplicableChecklist: boolean;
  }[];

  interactionType: string;

  dissatisfaction: string;
  sentiment: string;

  interactionCustomer: InteractionCustomer;
  interactionDebt: InteractionDebt;
  // lastStatus: InteractionStatus;

  attachments: InteractionAttachment[];

  agent?: Agent;

  justification?: Justification;

  wasPreManualMonitor?: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  public get lastStatusHistory(): InteractionStatus {
    let testeStatus = this.status.id !== InteractionStatusEnum.IN_ANALYSIS;

    if (this.status.id !== InteractionStatusEnum.IN_ANALYSIS) {
      return this.status;
    }

    if (this.analysisHistories.length == 0) {
      return {} as InteractionStatus;
    }

    let lastActiveStatus = this.lastAnalysisHistory;

    if (!lastActiveStatus) {
      return this.status;
    }

    return lastActiveStatus.interactionPreviousStatus;
  }

  public get lastAnalysisHistory(): AnalysisHistory {
    if (!this.analysisHistories || this.analysisHistories.length == 0) {
      return {} as AnalysisHistory;
    }

    return this.analysisHistories.find(item => item.active);
  }
}
